import {useState} from "react";
import {SubProduct, SubProductMarketingType, Vertical} from "@bounce/shared/consumer/declarations";
import {S3_BASE_URL} from "@bounce/shared/constants";
import autoMarketingTypeIconUrl from "~/assets/icon-marketing-type-auto.svg";
import beautyMarketingTypeIconUrl from "~/assets/icon-marketing-type-beauty.svg";
import electronicsMarketingTypeIconUrl from "~/assets/icon-marketing-type-electronics.svg";
import fashionMarketingTypeIconUrl from "~/assets/icon-marketing-type-fashion.svg";
import generalMarketingTypeIconUrl from "~/assets/icon-marketing-type-general.svg";
import healthcareMarketingTypeIconUrl from "~/assets/icon-marketing-type-healthcare.svg";
import homeMarketingTypeIconUrl from "~/assets/icon-marketing-type-home.svg";
import jewelryMarketingTypeIconUrl from "~/assets/icon-marketing-type-jewelry.svg";
import musicMarketingTypeIconUrl from "~/assets/icon-marketing-type-music.svg";
import petsMarketingTypeIconUrl from "~/assets/icon-marketing-type-pets.svg";
import CompanyLogo from "~/components/bundle/CompanyLogo";
import {PartnerLogo} from "./PartnerLogo";

const LOGO_SIZE = 40;

const MARKETING_TYPE_ICON_URLS: Partial<Record<SubProductMarketingType, string>> = {
  [SubProductMarketingType.AUTO]: autoMarketingTypeIconUrl,
  [SubProductMarketingType.HOME]: homeMarketingTypeIconUrl,
  [SubProductMarketingType.HEALTHCARE]: healthcareMarketingTypeIconUrl,
  [SubProductMarketingType.PETS]: petsMarketingTypeIconUrl,
  [SubProductMarketingType.ELECTRONICS]: electronicsMarketingTypeIconUrl,
  [SubProductMarketingType.JEWELRY]: jewelryMarketingTypeIconUrl,
  [SubProductMarketingType.FASHION]: fashionMarketingTypeIconUrl,
  [SubProductMarketingType.BEAUTY]: beautyMarketingTypeIconUrl,
  [SubProductMarketingType.MUSIC]: musicMarketingTypeIconUrl,
};

type DebtLogoProps = {
  vertical?: Vertical | null;
  subProduct?: SubProduct | null;
  partnerLogoUrl?: string;
  partnerName?: string;
};

export const DebtLogo = ({vertical, subProduct, partnerLogoUrl, partnerName}: DebtLogoProps) => {
  const [failedCardImageKey, setFailedCardImageKey] = useState<string>();
  const [posIconFailed, setPosIconFailed] = useState(false);
  const fallback = <PartnerLogo url={partnerLogoUrl} name={partnerName} size="md" />;
  const marketingName = subProduct?.marketing_name;
  if (!vertical || !marketingName) return fallback;

  if (vertical === Vertical.BNPL)
    return <CompanyLogo key={marketingName} companyName={marketingName} size={LOGO_SIZE} fallback={fallback} />;

  const cardImageKey = subProduct?.image_s3_key;
  if (vertical === Vertical.CREDIT_CARD && cardImageKey && cardImageKey !== failedCardImageKey)
    return (
      <img
        src={`${S3_BASE_URL}/${cardImageKey}`}
        alt={`${marketingName} card`}
        onError={() => setFailedCardImageKey(cardImageKey)}
        style={{height: LOGO_SIZE, width: "auto", flexShrink: 0}}
      />
    );

  if (vertical === Vertical.POS && !posIconFailed)
    return (
      <img
        src={
          (subProduct?.marketing_type && MARKETING_TYPE_ICON_URLS[subProduct.marketing_type]) ||
          generalMarketingTypeIconUrl
        }
        alt={`${marketingName} store`}
        onError={() => setPosIconFailed(true)}
        style={{height: LOGO_SIZE, width: LOGO_SIZE, flexShrink: 0}}
      />
    );

  return fallback;
};
